import {DatePipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';

const NULLABLE_DATE = '4000-01-01';

@Pipe({
    name: 'lsnDate'
})
export class LsnDatePipe extends DatePipe implements PipeTransform {
    transform(value: any, format = 'yyyy-MM-dd'): any {
        return value !== NULLABLE_DATE
            ? super.transform(value, format)
            : '';
    }
}
